/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import type { useGetCurrentStorageUsageGetCurrentStorageUsageQuery as useGetCurrentStorageUsageGetCurrentStorageUsageQuery$data } from './__types__/useGetCurrentStorageUsageGetCurrentStorageUsageQuery';

interface StorageInfo {
	currentUsage: number;
	isStorageEnforcementGracePeriodComplete?: boolean | null;
	gracePeriodEndDate?: string | null;
	loading: boolean;
	error?: Error;
}

export const useGetCurrentStorageUsage = ({
	skip,
}: {
	skip?: boolean;
} = {}): StorageInfo => {
	const { data, loading, error } =
		useQuery<useGetCurrentStorageUsageGetCurrentStorageUsageQuery$data>(
			gql`
				query useGetCurrentStorageUsageGetCurrentStorageUsageQuery {
					storage: confluence_storage {
						bytesUsed
						isStorageEnforcementGracePeriodComplete
						gracePeriodEndDate
					}
				}
			`,
			{
				skip,
			},
		);

	return {
		currentUsage: data?.storage?.bytesUsed ?? 0,
		isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
		gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
		loading,
		error,
	};
};
